import { ContentType } from 'enums';
import { getStreamForContent } from 'lib/format';

export default function convertV3ToV1(content) {
    const stream = getStreamForContent(content);
    const contentId = isNaN(parseInt(content.id, 10)) ? content.id : parseInt(content.id, 10);
    let v1Content;
    if (content.type === ContentType.LISTING) {
        v1Content = {
            id: contentId,
            status: content.status,
            type: 'event',
            name: content.name,
            description: content.description,
            imageHref: content.imageHref,
            duration: stream.duration,
            subtitle: content.subtitle,
            date: content.date,
            shortDate: content.shortDate,
            rawDate: content.utc,
            time: content.time,
            authTypes: stream.authTypes,
            airings: [
                {

                }
            ],
            source: stream.source.name,
            sourceId: stream.source.id,
            sourceType: stream.source.type,
            adobeRSS: stream.adobeRSS,
            links: stream.links,
            tracking: {
                // TODO: check if ESPN App uses this
            },
            iconHref: content.iconHref
        };
    } else if(content.type === ContentType.VOD) {
        v1Content = {
            id: contentId,
            guid: content.guid,
            type: 'video',
            name: content.name,
            description: content.description,
            imageHref: content.imageHref,
            duration: stream.duration,
            subtitle: content.subtitle,
            airings: [
                {
                    airingId: content.id
                }
            ],
            source: stream.source.name,
            links: stream.links,
            tracking: {
                // TODO: check if ESPN App uses this
            }
        };
    }
    return v1Content;
}



// WEBPACK FOOTER //
// ./app/lib/format/convertV3ToV1.js